export var DateFilterPickerPresets = /*#__PURE__*/ function(DateFilterPickerPresets) {
    DateFilterPickerPresets["AllTime"] = "all-time";
    DateFilterPickerPresets["Today"] = "today";
    DateFilterPickerPresets["ThisWeek"] = "this-week";
    DateFilterPickerPresets["ThisMonth"] = "this-month";
    DateFilterPickerPresets["PreviousMonth"] = "previous-month";
    DateFilterPickerPresets["LastThreeMonths"] = "last-three-months";
    return DateFilterPickerPresets;
}({});
